export const route = {
    shop: {
        points: {
            url: 'api/shop/points',
            method: 'post',
        },
        types: {
            url: 'api/shop/types',
            method: 'post',
        },
        listTypes: {
            url: 'api/shop/types/list',
            method: 'post',
        },
        adminProducts: {
            url: 'api/admin/main/page/products',
            method: 'post',
        },
        list: {
            url: 'api/shop/list',
            method: 'post',
        },
        product: {
            url: 'api/shop/product',
            method: 'post',
        },
        new: {
            url: 'api/shop/list/products/new',
            method: 'post',
        },
        popular: {
            url: 'api/shop/list/products/popular',
            method: 'post',
        },
    },
    order: {
        store: {
            url: 'api/shop/store',
            method: 'post',
        },
    },
    auth: {
        getUser: {
            url: 'api/user',
            method: 'post',
        },
        refresh: {
            url: 'api/refresh',
            method: 'post',
            intercept: false,
        },
        login: {
            url: 'api/login',
            method: 'post',
            auth: false,
        },
        registration: {
            url: 'api/registration',
            method: 'post',
        },
        reset: {
            url: 'api/reset',
            method: 'post',
        },
        reseted: {
            url: 'api/reseted',
            method: 'post',
        },
        logout: {
            url: 'api/logout',
            method: 'post',
        },
    },
    admin: {
        front: {
            edit: {
                url: 'api/admin/front/options/edit',
                method: 'post',
            },
        },
        images: {
            load: {
                url: 'api/admin/images',
                method: 'post',
            },
            store: {
                url: 'api/admin/image/store',
                method: 'post',
            },
            destroy: {
                url: 'api/admin/image/destroy',
                method: 'post',
            },
        },
    },
};
